<template>
    <div>
        <b-button variant="outline-primary" size="sm" @click="isOpen = true">
            {{ $t('producerSubscriptions.learnMore') }}
        </b-button>

        <b-modal
            v-model="isOpen"
            :title="title"
            :ok-disabled="loading"
            :ok-title="$t('producerSubscriptions.activate')"
            :cancel-title="$t('cancel')"
            @ok.prevent="activate"
        >
            <p class="mb-3">{{ $t('producerSubscriptions.activateDescription') }}</p>
            <p class="mb-3" v-html="description"></p>
            <ErrorMessage v-if="error" :value="error" />
        </b-modal>
    </div>
</template>

<script>
    import ErrorMessage from '@/components/common/ErrorMessage.vue';
    import spaceService from '@/services/spaceService';

    export default {
        components: {
            ErrorMessage,
        },
        props: {
            permission: String,
            title: String,
            description: String,
        },
        data() {
            return {
                isOpen: false,
                error: null,
                loading: false,
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
        },
        methods: {
            async activate() {
                this.loading = true;
                this.error = null;
                try {
                    await spaceService.activatePermission(this.spaceId, this.permission);
                    this.$emit('activated');
                    this.isOpen = false;
                } catch (e) {
                    this.error = e.message;
                    this.$emit('error', e);
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
